@import '../../../globals/main';

$gray100: #e9e6e5;

pn-animated-tile {
  .pn-animated-tile__container {
    position: relative;
    border-radius: 2.4rem;
    height: 56rem;

    cursor: default;
  }

  .pn-animated-tile__content {
    position: relative;
    display: flex;

    height: 100%;
    width: 100%;
    background-color: transparent;
  }

  [slot='side-a'],
  [slot='side-b'] {
    position: absolute;
    align-self: stretch;

    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  //initial slots' state
  [slot='side-a'] {
    padding: 0;
    opacity: 1;
  }

  [slot='side-b'] {
    z-index: -1;
    padding: 2.4rem 2.4rem 7rem 2.4rem;
    opacity: 0;
    transform: translateY(50px);
  }

  .pn-animated-tile__toggle {
    z-index: 2;
    position: absolute;
    bottom: 2.4rem;
    right: 2.4rem;
    padding: 0.8rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;

    background-color: $white;
    transition: background-color 0.45s ease-in-out;
    pn-icon {
      background-color: $white;
      transition:
        background-color 0.45s ease-in-out,
        transform 0.45s ease-in-out 0.5s;
    }

    &:hover {
      background-color: $gray100;
      pn-icon {
        background-color: $gray100;
      }
    }
  }

  .button-tooltip {
    display: none;
  }
}

//animations
.cat-animate {
  [slot='side-a'],
  [slot='side-b'] {
    transition:
      opacity 0.45s ease-in-out,
      transform 0.45s ease-in-out 0.5s;
  }

  &.fade {
    //from a to b
    [slot='side-a'] {
      opacity: 0;
      z-index: -1;
    }

    [slot='side-b'] {
      z-index: 1;
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.5s;
    }

    //from b to a
    &--reversed {
      [slot='side-a'] {
        opacity: 1;

        transition-delay: 0.5s;
      }

      [slot='side-b'] {
        opacity: 0;
        transform: translateY(50px);
      }
    }
  }

  &.toggle {
    &.animate {
      pn-icon {
        transform: rotate(45deg);
      }
    }
  }
}

//themes
[data-cat-theme='white'] {
  .pn-animated-tile__container {
    background-color: $white;
  }

  .pn-animated-tile__toggle {
    background-color: $blue400;
    pn-icon {
      background-color: $blue400;
      svg > path {
        fill: $white;
      }
    }

    &:hover {
      background-color: $blue700;
      pn-icon {
        background-color: $blue700;
      }
    }

    &:focus,
    &:focus-visible {
      outline-color: $blue700;
    }
  }
}

[data-cat-theme='coral400'] {
  .pn-animated-tile__container {
    background-color: $coral400;
  }

  .pn-animated-tile__toggle {
    background-color: $white;
    pn-icon {
      background-color: $white;
      svg > path {
        fill: $coral400;
      }
    }

    &:focus,
    &:focus-visible {
      outline-color: $coral400;
    }
  }
}

[data-cat-theme='private'] {
  .pn-animated-tile__container {
    background-color: $blue400;
  }

  .pn-animated-tile__toggle {
    background-color: $white;
    pn-icon {
      background-color: $white;
      svg > path {
        fill: $blue400;
      }
    }

    &:focus,
    &:focus-visible {
      outline-color: $blue400;
    }
  }
}

[data-cat-theme='business'] {
  .pn-animated-tile__container {
    background-color: $blue900;
  }

  .pn-animated-tile__toggle {
    background-color: $white;
    pn-icon {
      background-color: $white;
      svg > path {
        fill: $blue900;
      }
    }

    &:focus,
    &:focus-visible {
      outline-color: $blue900;
    }
  }
}

[data-cat-theme='hybrid'] {
  .pn-animated-tile__container {
    background-color: $gray100;
  }

  .pn-animated-tile__toggle {
    background-color: $white;
    pn-icon {
      background-color: $white;
      svg > path {
        fill: $blue700;
      }
    }

    &:focus,
    &:focus-visible {
      outline-color: $blue700;
    }
  }
}

[data-cat-firstpage-only='true'] {
  [slot='side-b'],
  .pn-animated-tile__toggle {
    display: none;
  }
}
